<template>

    <form ref="colaborador-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-8">
                <label for="nmCompleto">Nome Completo</label>
                <input type="text" class="form-control" :disabled="hasDisabled" name="nmCompleto" autocomplete="off" placeholder="Nome Completo" v-model="model.nmCompleto" maxlength="80" required />
            </div>
            <div class="form-group col-md-4">
                <label for="apelido">Prefiro ser chamado de</label>
                <input type="text" class="form-control" :disabled="hasDisabled" name="apelido" autocomplete="off" placeholder="Apelido" v-model="model.apelido" maxlength="30" required />
            </div>

            <div class="form-group col-md-4">
                <label for="email">E-mail</label>
                <input type="email" class="form-control" name="email" :disabled="!podeAlterarEmail || hasDisabled" autocomplete="off" placeholder="E-mail" v-model="model.email" maxlength="80" required />
            </div>
            <div class="form-group col-md-4">
                <label for="emailAlternativo">E-mail Alternativo</label>
                <input type="email" class="form-control" name="emailAlternativo" :disabled="hasDisabled" autocomplete="off" placeholder="E-mail Alternativo" maxlength="80" v-model="model.emailAlternativo" />
            </div>
            <div class="form-group col-md-4">
                <label for="dtNascimento">Nascimento</label>
                <input type="text" v-datepicker class="form-control" :disabled="hasDisabled" autocomplete="off" name="dtNascimento" v-model="model.dtNascimento" required />
            </div>

            <div class="form-group col-md-4">
                <label for="cpf">CPF</label>
                <input type="text" :disabled="!podeAlterarCPF || hasDisabled" class="form-control" name="cpf" v-mask="mask_cpf" maxlength="14" autocomplete="off" placeholder="___.___.___-__" v-model="model.cpf" required />
            </div>
            <div class="form-group col-md-4">
                <label for="rg">RG</label>
                <input type="text" class="form-control" v-mask="mask_rg" :disabled="hasDisabled" name="rG" autocomplete="off" maxlength="20" placeholder="__.___.___-_" v-model="model.rg" required />
            </div>
            <div class="form-group col-md-4">
                <label for="sexo">Sexo</label>
                <select v-model="model.sexo" class="form-control" name="sexo" :disabled="hasDisabled" required>
                    <option value="M">Masculino</option>
                    <option value="F">Feminino</option>
                </select>
            </div>

            <div class="form-group col-md-1">
                <label for="telefoneDDD">DDD</label>
                <input type="tel" class="form-control" name="telefoneDDD" :disabled="hasDisabled" :required="!model.celularDDD && !model.comercialDDD && !model.telefoneDDD" v-mask="'##'" maxlength="2" autocomplete="off" placeholder="__" v-model="model.telefoneDDD" />
            </div>
            <div class="form-group col-md-3">
                <label for="telefoneNumero">Telefone Residencial</label>
                <input type="text" class="form-control" name="telefoneNumero" :disabled="hasDisabled" :required="!model.celularNumero && !model.telefoneNumero && !model.telefoneComercial" v-mask="mask_tel" maxlength="10" autocomplete="off" placeholder="____-____" v-model="model.telefoneNumero" />
            </div>
            <div class="form-group col-md-1">
                <label for="ComercialDDD">DDD</label>
                <input type="tel" class="form-control" name="comercialDDD" :disabled="hasDisabled" :required="!model.celularDDD && !model.comercialDDD && !model.telefoneDDD" v-mask="'##'" maxlength="2" autocomplete="off" placeholder="__" v-model="model.comercialDDD" />
            </div>
            <div class="form-group col-md-3">
                <label for="telefoneComercial">Telefone/Celular Comercial</label>
                <input type="text" class="form-control" name="telefoneComercial" :disabled="hasDisabled" :required="!model.celularNumero && !model.telefoneNumero && !model.telefoneComercial" v-mask="mask_cel" maxlength="10" autocomplete="off" placeholder="____-____" v-model="model.telefoneComercial" />
            </div>
            <div class="form-group col-md-1">
                <label for="celularDDD">DDD</label>
                <input type="text" class="form-control" name="celularDDD" :disabled="hasDisabled" :required="!model.celularDDD && !model.comercialDDD && !model.telefoneDDD" v-mask="'##'" maxlength="2" autocomplete="off" placeholder="__" v-model="model.celularDDD" />
            </div>
            <div class="form-group col-md-3">
                <label for="celularNumero">Celular</label>
                <input type="text" class="form-control" name="celularNumero" :disabled="hasDisabled" :required="!model.celularNumero && !model.telefoneNumero && !model.telefoneComercial" v-mask="mask_cel" maxlength="10" autocomplete="off" placeholder="_____-____" v-model="model.celularNumero" />
            </div>

            <div class="form-group col-md-2">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ehEstrangeiro" class="custom-control-input" v-model="model.ehEstrangeiro" :disabled="hasDisabled">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Estrangeiro?</span>
                </label>
            </div>
            <div class="form-group col-md-10" v-if="model.ehEstrangeiro">
                <label for="nacionalidadeId">Nacionalidade</label>
                <select v-select="{ dataitem: 'Nacionalidade', default: 'Selecione' }" v-model="model.nacionalidadeId" :disabled="hasDisabled" class="form-control" name="nacionalidadeId" required></select>
            </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" v-if="!hasDisabled" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    import auth from '@/common/auth'

    export default {
        name: "colaborador-form-edit",
        mixins: [base],
        props: { id: Number, hasDisabled: Boolean },
        data: () => ({

            model: {},

            form: "colaborador-form-edit",

        }),

        computed: {
            podeAlterarCPF: function () {
                var podeAlterar = auth.canAccess('/colaborador/alterarcpf');
                return podeAlterar;
            },
            podeAlterarEmail: function () {
                var podeAlterar = auth.canAccess('/colaborador/alteraremail');
                return (podeAlterar || !this.hasDisabled && this.model.situacaoJobsId != 3);
            },
        },

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;
                if (this.model.telefoneNumero) model.telefoneNumero = model.telefoneNumero.replace(/\D+/g, '');
                if (this.model.celularNumero) model.celularNumero = model.celularNumero.replace(/\D+/g, '');
                model.cpf = model.cpf.replace(/\D+/g, '');
                model.rg = model.rg.replace(/\D+/g, '');

                this.showLoading();

                new Api('colaborador').put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                if (!_valid) this.defaultErrorResult("Preencha todos os campos obrigatórios");
                return _valid;
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api('colaborador').get({ colaboradorId: this.id }).then(data => {                
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
                //console.log("dados.............:", this.model);
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>
